module.exports = __webpack_public_path__ + "media/components/donate/static/dafdirect-d2e2928f5de578fadeb79a6f209c2472.png";